import { useAppSelector } from 'hooks/reduxHooks'
import { EmptyObject } from 'lib/object/objectUtils'
import useOfferListKey from './useOfferListKey'

function useOfferMetaData(offerId: string, filters: App.OfferListFilters = EmptyObject): App.OfferListMetaData | undefined {
  const offerMetaDataKey = useOfferListKey(filters)

  return useAppSelector(state => state.offer.searchResultMetadata.offerMetaData[offerMetaDataKey]?.[offerId])
}

export default useOfferMetaData
